import React, { MouseEvent } from 'react'
import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'
import { TablePaginationActionsProps } from '@material-ui/core/TablePagination/TablePaginationActions'

const TablePaginationActions: React.FC<TablePaginationActionsProps> = (props) => {
  const { count, page, rowsPerPage, onPageChange } = props
  const theme = useTheme()

  const handleFirstPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => { onPageChange(event, 0) }

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => { onPageChange(event, page - 1) }

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => { onPageChange(event, page + 1) }

  const handleLastPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => { onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1)) }

  return (
    <Box display="flex" flexShrink={0} color={theme.palette.text.secondary} marginLeft={2.5}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0}>
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
        <KeyboardArrowLeftIcon />
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
        <KeyboardArrowRightIcon />
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
        <LastPageIcon />
      </IconButton>
    </Box>
  )
}

export default React.memo(TablePaginationActions)
